import React, { useState, useRef, useEffect } from "react";
import sortIcon from '../../../assets/common/sort-icon.svg'
import tick from "../../../assets/dashboard/tick.svg";

const TableSortDropdown = ({
    label,
    options,
    value,
    onChange,
    className = "",
}) => {
    const [open, setOpen] = useState(false);
    const ref = useRef(null);

    useEffect(() => {
        const handleClickOutside = (e) => {
            if (ref.current && !ref.current.contains(e.target)) {
                setOpen(false);
            }
        };

        document.addEventListener("mousedown", handleClickOutside);
        return () =>
            document.removeEventListener("mousedown", handleClickOutside);
    }, []);

    return (
        <div
            ref={ref}
            className={`relative flex items-center justify-center ${className}`}
        >
            <div
                className="flex items-center gap-3 cursor-pointer select-none"
                onClick={() => setOpen((prev) => !prev)}
            >
                {label}
                <img src={sortIcon} alt="sortIcon" />
            </div>

            {open && (
                <div className="absolute top-6 left-0 px-2 mt-2 w-44 bg-white shadow-lg rounded-md border border-gray-200 text-primary z-50">
                    <div className="px-4 py-2 text-sm font-bold text-primary border-b">
                        Order by
                    </div>

                    {options.map((option) => (
                        <button
                            key={option.value}
                            onClick={() => {
                                onChange(option.value);
                                setOpen(false);
                            }}
                            className={`w-full my-2 p-2 hover:bg-lightBlue flex gap-1 items-center justify-center rounded-md ${value === option.value ? "bg-lightBlue font-medium" : "font-medium"
                                }`}
                        >
                            {value === option.value && <span><img src={tick} alt="tick" className="w-2 h-2" /></span>}
                            <span>{option.label}</span>
                        </button>
                    ))}
                </div>
            )}
        </div>
    );
};

export default TableSortDropdown;